import {
    PERFORMANCE_BENCHMARK_OPTIONS_SET,
    PERFORMANCE_BENCHMARK_OPTIONS_UPDATED,
    PERFORMANCE_SET
} from './constant';
export default {
    setHousehold(state, response) {
        state.household = response.household
        state.companyLogo = response.additionalData.companyLogo
        state.planStartDate = response.additionalData.planStartDate
        state.planAge = response.additionalData.planAge
        state.planLength = response.additionalData.planLength
        state.incomeBucketStyles = response.additionalData.incomeBucketStyles
        state.incomeBuckets = response.additionalData.incomeBuckets
        state.brokerageAccountGrowthTypes = response.additionalData.brokerageAccountGrowthTypes
        state.benchmark = response.additionalData.benchmark
        state.incomeStreams = response.additionalData.incomeStreams
        state.incomeStream = response.additionalData.incomeStream
        state.incomeStreamStyles = response.additionalData.incomeStreamStyles
        state.cashAccount = response.additionalData.cashAccount
        state.individuals = response.additionalData.individuals
        state.beneficiaries = response.additionalData.beneficiaries
        state.iavAccountGroupedTypeLabels = response.additionalData.iavAccountGroupedTypeLabels
        state.iavAccountOwnerTypes = response.additionalData.iavAccountOwnerTypes
        state.iavAccounts = response.additionalData.iavAccounts
        state.lifeInsuranceTypes = response.additionalData.lifeInsuranceTypes
        state.otherIncomes = response.additionalData.otherIncomes
        state.otherIncomeTypes = response.additionalData.otherIncomeTypes
        state.lifeInsurances = response.additionalData.lifeInsurances
        state.relativeYearMonthlyIncome = response.additionalData.relativeYearMonthlyIncome
        state.relativeYearMonthlyNeeds = response.additionalData.relativeYearMonthlyNeeds
        state.relativeYearBrokerageAccountStartingBalance = response.additionalData.relativeYearBrokerageAccountStartingBalance
        state.relativeYearBenchmarkStartingBalance = response.additionalData.relativeYearBenchmarkStartingBalance
        state.sipsTable = response.additionalData.sipsTable
        state.growthSipsTable = response.additionalData.growthSipsTable
        state.annualSavings = response.additionalData.annualSavings
        state.personOneAgeThroughYears = response.additionalData.personOneAgeThroughYears
        state.personTwoAgeThroughYears = response.additionalData.personTwoAgeThroughYears
        state.yearsPeopleDie = response.additionalData.yearsPeopleDie
        state.years = response.additionalData.years
        state.brokerageAccount = response.additionalData.brokerageAccount
        state.relativePlanYearDropdown = response.additionalData.relativePlanYearDropdown
        state.incomeBucketCoveredPerson = response.additionalData.incomeBucketCoveredPerson
        state.incomeBucketCoveredPersonLabels = response.additionalData.incomeBucketCoveredPersonLabels
        state.lifeInsuranceTypeLabels = response.additionalData.lifeInsuranceTypeLabels
        state.savingsAccountValueCalculationMethods = response.additionalData.savingsAccountValueCalculationMethods
        state.savingsAccount = response.additionalData.savingsAccount
        state.iavAccountTypeLabels = response.additionalData.iavAccountTypeLabels
        state.integrations = response.additionalData.integrations
        state.estimatedCurrentIncome = response.additionalData.estimatedCurrentIncome
        state.relativeYearPortfolioStartingBalance = response.additionalData.relativeYearPortfolioStartingBalance
        state.iavAccountsStatistics = response.additionalData.iavAccountsStatistics
        state.plannedAssetsTotal = response.additionalData.plannedAssetsTotal
        state.incomeBucketsStatistics = response.additionalData.incomeBucketsStatistics
        state.successMeter = response.additionalData.successMeter
        state.riskMeter = response.additionalData.riskMeter
        state.properties = response.additionalData.properties
        state.liabilities = response.additionalData.liabilities
        state.individualsDropdown = response.additionalData.individualsDropdown
        state.loading = false
    },

    setPerformanceIndicies(state, response) {
        state.performanceIndicies = response.performanceIndicies
    },

    [PERFORMANCE_SET](state, performance) {
        state.performance = performance;
    },

    [PERFORMANCE_BENCHMARK_OPTIONS_SET](state, options) {
        state.performanceOptions = options
    },

    [PERFORMANCE_BENCHMARK_OPTIONS_UPDATED](state, {optionId, enabled}) {
        let option = state.performanceOptions.find((option) => option.id === optionId );
        if (option) {
            option.enabled = enabled;
        }
    },

    ['INTEGRATION_STATUS_SET'](state, data) {
        state.integrationStatus.performance_reporting_active = data.performance_reporting_active;
        state.integrationStatus.data_aggregation_active = data.data_aggregation_active;
    },

    setFinancialSummary(state, response) {
        state.financialSummary = response.financial_summary;
    },

    setPositions(state, positions) {
        state.positions = positions;
    },
}
